import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import CalendarLoader from "../../../common-components/CalendarLoader";

const BMILogsDatewise = () => {
  const { bmiChart, bmiChartError, bmiChartLoading } = useSelector(
    (state) => state.prospects
  );

  const [bmiStats, setBMIStats] = useState([]);

  const sortedStats = [...bmiStats].sort((a, b) => {
    const dateA = new Date(a?.date?.split("-").reverse().join("-"));
    const dateB = new Date(b?.date?.split("-").reverse().join("-"));
    return dateA - dateB;
  });

  useEffect(() => {
    if (
      !bmiChartError &&
      !bmiChartLoading &&
      bmiChart?.status &&
      bmiChart?.data
    ) {
      setBMIStats(bmiChart.data);
    } else {
      setBMIStats([]);
    }
  }, [bmiChart, bmiChartError, bmiChartLoading]);

  return (
    <div className="tme-analysis-chart-logs-section tme-analysis-chart-logs-green">
      <h4 className="tme-analysis-chart-logs-title">BMI Logs Comparison</h4>

      <div className="tme-analysis-chart-logs-grid">
        {bmiChartLoading ? (
          <CalendarLoader daysCount={4} />
        ) : (
          sortedStats.map((log, idx) => {
            const currentBMI = parseFloat(log?.bmi_result || 0);
            const prevBMI =
              idx > 0 ? parseFloat(sortedStats[idx - 1]?.bmi_result || 0) : null;
            const change = prevBMI
              ? (currentBMI - prevBMI).toFixed(1)
              : null;
            const changeType = change ? (change < 0 ? "down" : "up") : null;

            return (
              <div key={log?.id} className="tme-analysis-chart-log-card">
                <div className="tme-analysis-chart-log-day">
                  {moment(log?.date, "DD-MM-YYYY").format("dddd, MMMM YYYY")}
                </div>
                <div className="tme-analysis-chart-log-value">
                  {currentBMI ? currentBMI.toFixed(2) : "-"}
                </div>
                {change && (
                  <div
                    className={`tme-analysis-chart-log-change ${
                      changeType === "down"
                        ? "tme-analysis-chart-change-up"
                        : "tme-analysis-chart-change-down"
                    }`}
                  >
                    {changeType === "down" ? "↘" : "↗"} {change}
                  </div>
                )}
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default BMILogsDatewise;
